<div
  class="checkout-floating-button"
  data-testid="global-cart-btn"
  role="button"
  tabindex="0"
  aria-label="Ver carrinho"
  (click)="showPage()"
  [style]="style"
>
  <div class="checkout-content">
    <div class="cart-icon-container">
      <ion-icon name="cart" class="cart-icon"></ion-icon>
      <div class="item-count" *ngIf="itemCount > 0">{{ itemCount }}</div>
    </div>

    <div class="checkout-text">
      <span class="checkout-label">Ver Carrinho</span>
      <span class="checkout-subtitle" *ngIf="itemCount > 0">
        {{ itemCount }} {{ itemCount === 1 ? 'item' : 'itens' }}
      </span>
    </div>

    <div class="checkout-cta">
      <span class="checkout-price" *ngIf="totalPrice > 0">
        {{ totalPrice | currency:'BRL':'symbol':'1.2-2':'pt' }}
      </span>
      <span class="checkout-arrow" aria-hidden="true">
        <ion-icon name="arrow-forward-outline" class="arrow-icon"></ion-icon>
      </span>
    </div>
  </div>

  <div class="checkout-ripple"></div>
</div>
